export function cookieExists(cookies: string, name: string): boolean {
  const cookie = (cookies || '')
    .split(';')
    .map((cookie) => cookie.replace(/^\s+|\s+$/g, ''))
    .find((cookie) => {
      return cookie.split('=')[0] === name;
    });
  return !!cookie;
}

/**
 * @deprecated Use useCookieStorage instead
 */
export function setCookie(
  cookie_name: string,
  current_value: string,
  expiration_days: number
): string {
  if (typeof document === 'undefined') {
    return '';
  }
  const expiration = new Date().setDate(new Date().getDate() + expiration_days);
  const secure = location.protocol === 'https:' ? 'Secure;' : '';
  const sameSite = location.protocol === 'https:' ? 'None' : 'Lax';
  const cookie = `${cookie_name}=${encodeURIComponent(
    current_value
  )};path=/; SameSite=${sameSite}; ${secure} expires=${new Date(
    expiration
  ).toUTCString()};`;
  document.cookie = cookie;
  return current_value;
}

/**
 * @deprecated Use useCookieStorage instead
 */
export function getCookie(cookie_name: string): string | null {
  if (typeof document === 'undefined') {
    return '';
  }
  const existing = document.cookie.split('; ').filter(function (cookie) {
    return cookie.indexOf(cookie_name + '=') === 0;
  })[0];
  const value = existing
    ? decodeURIComponent(existing.split('=')[1] || '')
    : null;
  return value;
}
